import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api/apiServises';
import { ADD_ASSEMBLY_STAGE_ONE_LIST, ADD_ASSEMBLY_STAGE_THREE_LIST, DATA_GET_ASSEMBLY_STAGE_THREE_HISTORY, FETCH_ASSEMBLY_STAGE_ONE_FORM, FETCH_ASSEMBLY_STAGE_ONE_LIST, FETCH_ASSEMBLY_STAGE_THREE_FORM_LIST, GET_ASSEMBLY_STAGE_THREE_LIST, GET_SHELL_NUMBER, UPDATE_ALL_ONE_ACTION, DELETE_ASSEMBLY_DATA,UPDATE_SHELL_ASSEMBLY_STATUS,UPDATE_SHELL_ASSEMBLY_STAGE_THREE_STATUS } from '../../../api/apiConstant';


export const fetchAssemblyStageOneForm = createAsyncThunk(
  'assembly/fetchAssemblyStageOneForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_ASSEMBLY_STAGE_ONE_FORM, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch assembly');
    }
  },
);

export const fetchAssemblyStageOneList = createAsyncThunk(
  'assembly/fetchAssemblyStageOneList',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_ASSEMBLY_STAGE_ONE_LIST, {params:{...formData}});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch assembly');
    }
  },
);
export const AddAssemblyStageOneList = createAsyncThunk(
  'assembly/AddAssemblyStageOneList',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_ASSEMBLY_STAGE_ONE_LIST, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch assembly');
    }
  },
);
export const AddAssemblyStageThreeList = createAsyncThunk(
  'assembly/AddAssemblyStageThreeList',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_ASSEMBLY_STAGE_THREE_LIST, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch assembly');
    }
  },
);
export const getShellNumber = createAsyncThunk(
  'assembly/getShellNumber',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_SHELL_NUMBER);
      // const response = await api.post(GET_SHELL_NUMBER, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch assembly');
    }
  },
);

export const fetchAssemblyStageThreeFormList = createAsyncThunk(
  'assembly/fetchAssemblyStageThreeFormList',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_ASSEMBLY_STAGE_THREE_FORM_LIST, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);
export const fetchAssemblyStageThreeList = createAsyncThunk(
  'assembly/fetchAssemblyStageThreeList',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_ASSEMBLY_STAGE_THREE_LIST, {params:{...formData}});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const assemblyStageThreeAction = createAsyncThunk(
  'assembly/assemblyStageThreeAction',
  async (formData, { rejectWithValue }) => {
    try {
      console.log('patni',formData);
      const response = await api.post(UPDATE_ALL_ONE_ACTION, {...formData});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchAssemblyStageThreeFlowHistory = createAsyncThunk(
  'assembly/fetchAssemblyStageThreeFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(DATA_GET_ASSEMBLY_STAGE_THREE_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch history');
    }
  },
);

export const deleteAssemblyData = createAsyncThunk(
  'furnishing/deleteAssemblyData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_ASSEMBLY_DATA, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);


export const updateShellAssemblyStatus = createAsyncThunk(
  'assembly/updateShellAssemblyStatus',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_SHELL_ASSEMBLY_STATUS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to update assembly status');
    }
  },
);


export const updateShellAssemblyStageThreeStatus = createAsyncThunk(
  'assembly/updateShellAssemblyStageThreeStatus',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_SHELL_ASSEMBLY_STAGE_THREE_STATUS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to update assembly status');
    }
  },
);

